import { render, staticRenderFns } from "./AddNewConfigurationSalesLinkedin.vue?vue&type=template&id=4df87e7a&scoped=true&"
import script from "./AddNewConfigurationSalesLinkedin.vue?vue&type=script&lang=js&"
export * from "./AddNewConfigurationSalesLinkedin.vue?vue&type=script&lang=js&"
import style0 from "./AddNewConfigurationSalesLinkedin.vue?vue&type=style&index=0&id=4df87e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df87e7a",
  null
  
)

export default component.exports